<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-actions">
				<div className="sf-actions__left">
					<!--저장 -->
					<sf-button line v-if="isButton_(scrId, 'CU')" icon="file" :onClick="saveAction">{{ getMessage_('SWCC000327') }}</sf-button>
					<!--삭제-->
					<!-- <sf-button line v-if="cmpnMstPopup.deleteBtn && isButton_(scrId, 'CD')" icon="trash" color="error" :onClick="deleteAction">{{
						getButtonMsg_(scrId, 'CD')
					}}</sf-button> -->
				</div>
			</div>
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001061') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--캠페인No-->
							<th class="col-1">{{ getMessage_('QWCC001024') }}</th>
							<td class="col-1">
								<el-input :value="cmpnMstPopup.cmpnNo" maxlength="20" @input="val => onChangePopup(val, 'cmpnNo')" readonly />
							</td>
							<!--캠페인명-->
							<th class="col-1">* {{ getMessage_('QWCC001007') }}</th>
							<td class="col-1"><el-input :value="cmpnMstPopup.cmpnNm" maxlength="60" @input="val => onChangePopup(val, 'cmpnNm')" /></td>
							<!-- 발생지역
							<th class="col-1">* {{ getMessage_('QWCC001050') }}</th>
							<td class="col-1">
								<select-combo
									paramKey="occuRegn"
									:options="occuRegnListPop"
									:propData="cmpnMstPopup.occuRegn"
									@commChange="onChangeSelect"
								/>
							</td> -->
							<!--문제유형-->
							<th class="col-1">* {{ getMessage_('QWCC001069') }}</th>
							<td class="col-1">
								<select-combo
									paramKey="prbmType"
									:propData="cmpnMstPopup.prbmType"
									:options="prbmTypeListPop"
									@commChange="onChangeSelect"
								/>
							</td>
							<!--캠페인시작일-->
							<th class="col-1">* {{ getMessage_('QWCC001025') }}</th>
							<td class="col-1">
								<el-date-picker
									:value="cmpnMstPopup.strtDd"
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									@input="val => onChangeDt(val, 'strtDd')"
								/>
							</td>
							<!--캠페인종료일-->
							<th class="col-1">* {{ getMessage_('QWCC001026') }}</th>
							<td class="col-1">
								<el-date-picker
									:value="cmpnMstPopup.endDd"
									format="yyyy-MM-dd"
									value-format="yyyyMMdd"
									@input="val => onChangeDt(val, 'endDd')"
								/>
							</td>
							<!-- 기종
							<th class="col-1">* {{ getMessage_('QWCC000973') }}</th>
							<td class="col-1">
								<select-combo paramKey="tymaCd" :propData="cmpnMstPopup.tymaCd" :options="tymaCdListPop" @commChange="onChangeSelect" />
							</td> -->
						</tr>

						<tr>
							<!--캠페인유형-->
							<th class="col-1">* {{ getMessage_('QWCC001071') }}</th>
							<td class="col-1">
								<select-combo
									paramKey="cmpnType"
									:propData="cmpnMstPopup.cmpnType"
									:options="cmpnTypeListPop"
									@commChange="onChangeSelect"
								/>
							</td>
							<!--원인부품-->
							<th class="col-1">* {{ getMessage_('QWCC001028') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="causPartNo"
												class="inputWithIcon"
												@keyup.native.delete="onCausPartNoInuPutKeyDown()"
												@change="onCausPartNoInuPutKeyDown"
												:readonly="cmpnMstPopup.readOnlyAuth"
											></el-input>
											<i class="icon-sf-search search-icon" @click="onCausePartPopup"></i>
										</div>
									</el-col>
								</div>
							</td>
							<td class="col-1" colspan="2"><el-input :value="causPartNm" readonly /></td>
							<!-- 협력사 -->
							<th class="col-1">* {{ getMessage_('QWCC000958') }}</th>
							<td class="col-1">
								<el-input :value="cmpnMstPopup.cpnyCd" readonly></el-input>
								<!-- <div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="menuCmpnCd"
												@keyup.native.delete="onMenuCmpnCdInPutKeyDown()"
												class="inputWithIcon"
												@change="onMenuCmpnCdInPutKeyDown"
											></el-input>
											<i class="icon-sf-search search-icon" @click="() => onCmpnPopup()"></i>
										</div>
									</el-col>
								</div> -->
							</td>
							<td class="col-1" colspan="2">
								<el-input :value="cmpnMstPopup.cpnyNm" readonly />
							</td>
						</tr>
						<tr>
							<!--원인코드-->
							<th class="col-1">* {{ getMessage_('QWCC001029') }}</th>
							<td class="col-1">
								<el-col>
									<div class="search-option-wrapper__normal">
										<el-input
											v-model="cmpnMstPopup.causCd"
											class="inputWithIcon"
											@keyup.native.delete="onCausCdInuPutKeyDown()"
											@change="onCausCdInuPutKeyDown"
										></el-input>
										<i class="icon-sf-search search-icon" @click="() => onCausCdPopup()"></i>
									</div>
								</el-col>
								<!-- <select-combo paramKey="causCd" :propData="cmpnMstPopup.causCd" :options="causCdListPop" @commChange="onChangeSelect" /> -->
							</td>
							<td class="col-1" colspan="2"><el-input :value="cmpnMstPopup.causNm" readonly /></td>
							<!--지역세부-->
							<th class="col-1">{{ getMessage_('QWCC001051') }}</th>
							<td class="col-1">
								<el-input :value="cmpnMstPopup.dtlRegn" maxlength="30" @input="val => onChangePopup(val, 'dtlRegn')" />
							</td>
							<th class="col-1">{{ getMessage_('QWCC001924') }}</th>
							<!--실납품사-->
							<td class="col-1" colspan="3">
								<el-input :value="cmpnMstPopup.dlvgNm" readonly />
							</td>
						</tr>

						<tr>
							<!--현상코드-->
							<th class="col-1">* {{ getMessage_('QWCC001055') }}</th>
							<td class="col-1">
								<div class="sf-input-group-wrapper">
									<el-col>
										<div class="search-option-wrapper__normal">
											<el-input
												v-model="phmnCd"
												class="inputWithIcon"
												@keyup.native.delete="onPhmnCdInuPutKeyDown()"
												@change="onPhmnCdInuPutKeyDown"
											></el-input>
											<i class="icon-sf-search search-icon" @click="() => onPhmnPopup()"></i>
										</div>
									</el-col>
								</div>
							</td>
							<td class="col-1" colspan="2"><el-input :value="phmnNm" readonly /></td>
							<!--대상수량-->
							<th class="col-1">{{ getMessage_('QWCC001027') }}</th>
							<td class="col-1"><el-input :value="cmpnMstPopup.subjQty" @input="val => onChangePopup(val, 'subjQty')" readonly /></td>
							<!--처리수량-->
							<th class="col-1">{{ getMessage_('QWCC002072') }}</th>
							<td class="col-1"><el-input :value="cmpnMstPopup.cmpnQty" @input="val => onChangePopup(val, 'cmpnQty')" readonly /></td>
							<!--처리율-->
							<th class="col-1">{{ getMessage_('QWCC002073') }}</th>
							<td class="col-1"><el-input :value="cmpnMstPopup.procRt" @input="val => onChangePopup(val, 'procRt')" readonly /></td>
						</tr>
						<tr>
							<!--대상기간-->
							<th class="col-1">{{ getMessage_('QWCC001065') }}</th>
							<td class="col-1"><el-input :value="cmpnMstPopup.prdtStrtDd" readonly :placeholder="getMessage_('QWCC001067')" /></td>
							<td class="col-1" colspan="1">
								<el-input :value="cmpnMstPopup.prdtEndDd" readonly :placeholder="getMessage_('QWCC001067')" />
							</td>
							<!--현상내용-->
							<th class="col-1">{{ getMessage_('QWCC001072') }}</th>
							<td class="col-1" colspan="6">
								<el-input :value="cmpnMstPopup.phmnSbc" maxlength="300" @input="val => onChangePopup(val, 'phmnSbc')" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import * as yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import

export default {
	props: {
		scrId: { type: String, default: '' },
		sendParam1: { type: Object }, //협력사
		sendParam2: { type: Object }, //공통코드(현상코드)
		sendParam3: { type: Object } //원인부품
	},
	components: { SelectCombo },
	data() {
		return {
			//협력사 팝업 저장하는 객체
			didGetManuCmpnCd: false,
			menuCmpnCd: '', //협력사 코드
			menuCmpnNm: '', //협력사
			manuCmpn: {
				cpnyCd: '',
				cpnyNm: '',
				cpnyScn: '10'
			},
			//현상코드 팝업 저장하는 객체
			didGetPhmnCdNm: false,
			phmnCd: '' /* 현상코드 */,
			phmnNm: '', //현상코드명
			commCd: {
				commCdType: 'PHMN_CD',
				commCdTypeName: '',
				mstUseYn: '',
				commCdTypeSort: '',
				commCd: '',
				commCdName: '',
				title: '',
				commCdSeq: '',
				useYn: '',
				refCd1: '',
				refCd2: '',
				refCd3: '',
				refCd4: '',
				refCd5: ''
			},
			causPartNo: '' /* 원인부품번호 */,
			causPartNm: '' /*원인부품명*/
		};
	},
	async created() {
		this.$sf_toggleLoading(true);
		await this.postSelectList_();

		this.menuCmpnCd = this.cmpnMstPopup.cpnyCd; //협력사코드
		this.menuCmpnNm = this.cmpnMstPopup.cpnyNm; //협력사명

		this.causPartNo = this.cmpnMstPopup.causPartNo; //원인코드
		this.causPartNm = this.cmpnMstPopup.causPartNm; //원인코드명

		this.phmnCd = this.cmpnMstPopup.phmnCd; //현상코드
		this.phmnNm = this.cmpnMstPopup.phmnNm; //현상코드명
		this.$sf_toggleLoading(false);
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		insVali() {
			//유효성 검사는 역순이다
			return yup.object().shape({
				causCd: yup //원인코드
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001029')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001029')])),
				cmpnType: yup //캠페인유형
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001071')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001071')])),
				endDd: yup //종료일
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001026')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001026')])),
				strtDd: yup //시작일
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001025')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001025')])),
				prbmType: yup //문제유형
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001069')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001069')])),
				cpnyCd: yup //협력사
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000958')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000958')])),
				cpnyNm: yup //협력사명
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000958')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000958')])),
				cmpnNm: yup //캠페인명
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001007')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001007')]))
				// cmpnNo: yup //캠페인명
				// 	.string()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001024')]))
				// 	.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001024')]))
				// 	.matches(/^[A-Za-z0-9]*$/, this.$sf_formatString(this.getMessage_('QWCC001812'), [this.getMessage_('QWCC001024')])) //[{0}]은(는) 영문과 숫자만 입력할 수가 있습니다. dtc, //{0}은(는) 팔수 입력 값 입니다. ,  DTC
			});
		},
		insValiPopup() {
			//유효성 검사는 역순이다
			return yup.object().shape({
				phmnNm: yup //현상코드
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001055')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001055')])),
				causPartNm: yup //원인부품코드
					.string()
					.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001028')]))
					.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC001028')]))
				// menuCmpnNm: yup //협력사
				// 	.string()
				// 	.typeError(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000959')]))
				// 	.required(this.$sf_formatString(this.getMessage_('QWCC001110'), [this.getMessage_('QWCC000959')]))
			});
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChangePopup(value, key) {
			// 검색조건 하이픈 자동추가 함수
			// if (key === 'cmpnNm') {
			// 	value = value.replace(/[^0-9]/g, '');

			// 	const arrValue = value.split('');

			// 	const textArr = [
			// 		[0, arrValue.length > 9 ? 3 : 2],
			// 		[0, arrValue.length > 10 ? 4 : 3],
			// 		[0, 4]
			// 	];

			// 	value = textArr
			// 		.map(function (v) {
			// 			return arrValue.splice(v[0], v[1]).join('');
			// 		})
			// 		.filter(function (text) {
			// 			return text;
			// 		})
			// 		.join('-');
			// }
			this.setCmpnMstPopup_({ key, value });
		},
		onChangeDt(value, key) {
			try {
				if (key === 'strtDd') {
					if (this.cmpnMstPopup.endDd && value && this.cmpnMstPopup.endDd < value) {
						throw new Error(this.$sf_formatString(this.getMessage_('QWCC001778')));
					} else {
						this.setCmpnMstPopup_({ key, value });
					}
				}
				if (key === 'endDd') {
					if (value && value < this.cmpnMstPopup.strtDd) {
						throw new Error(this.$sf_formatString(this.getMessage_('QWCC001778')));
					} else {
						this.setCmpnMstPopup_({ key, value });
					}
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error?.message });
			}
		},
		onChangeSelect(param) {
			this.setCmpnMstPopup_(param);
		},
		// onMenuCmpnCdInPutKeyDown() {
		// 	this.menuCmpnCd = '';
		// 	this.menuCmpnNm = '';
		// },
		onCausPartNoInuPutKeyDown() {
			this.causPartNo = ''; //원인부품
			this.causPartNm = ''; //원인부품명
			this.setCmpnMstPopup_({ key: 'cpnyCd', value: '' });
			this.setCmpnMstPopup_({ key: 'cpnyNm', value: '' });
			this.setCmpnMstPopup_({ key: 'dlvgNm', value: '' });
		},
		onPhmnCdInuPutKeyDown() {
			this.phmnCd = ''; //현상코드
			this.phmnNm = ''; //현상코드명
		},
		onCausCdInuPutKeyDown() {
			this.setCmpnMstPopup_({ key: 'causCd', value: '' });
			this.setCmpnMstPopup_({ key: 'causNm', value: '' });
		},
		// onCmpnPopup(param) {
		// 	//협력사 팝업
		// 	this.manuCmpn.cpnyCd = this.menuCmpnCd;
		// 	this.$emit('OpenCmpnPopup', this.manuCmpn);
		// },
		onPhmnPopup(param) {
			//현상코드 팝업
			this.commCd.commCdType = 'PHMN_CD';
			this.commCd.commCd = this.phmnCd;
			this.commCd.title = this.getMessage_('QWCC001055');

			this.$emit('OpenComCodePopup', this.commCd);
		},
		onCausePartPopup() {
			//부품코드 팝업
			if (this.cmpnMstPopup.readOnlyAuth == false) {
				this.partNoInput = this.causPartNo;
				this.$emit('OpenPopupPartNo', this.partNoInput);
			}
		},
		onCausCdPopup() {
			//원인코드 팝업
			this.commCd.commCdType = 'CAUS_CD';
			this.commCd.commCd = this.cmpnMstPopup.causCd;
			this.commCd.title = this.getMessage_('QWCC001029');

			this.$emit('OpenPopupCausCd', this.commCd);
		},
		compSet(param) {
			//원인부품 선택 시 협력사 선택
			this.setCmpnMstPopup_({ key: 'cpnyCd', value: param.cpnyCd });
			this.setCmpnMstPopup_({ key: 'cpnyNm', value: param.cpnyNm });
			this.setCmpnMstPopup_({ key: 'dlvgNm', value: param.dlvgNm });
		},
		saveAction() {
			try {
				//this.setCmpnMstPopup_({ key: 'cpnyCd', value: convertNvl(this.menuCmpnCd, '') });
				this.setCmpnMstPopup_({ key: 'phmnCd', value: convertNvl(this.phmnCd, '') });
				this.setCmpnMstPopup_({ key: 'causPartNo', value: convertNvl(this.causPartNo, '') });

				const saveParams = this.cmpnMstPopup;
				const popupParams = {
					menuCmpnNm: this.menuCmpnNm,
					causPartNm: this.causPartNm,
					phmnNm: this.phmnNm
				};
				//벨리데이션 체크
				this.insVali.validateSync(saveParams);
				this.insValiPopup.validateSync(popupParams);

				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
					buttons: [{ title: this.getMessage_('SWCC000278'), clickFn: this.save }] //저장
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async save() {
			this.$sf_toggleLoading(true);
			const saveParams = this.cmpnMstPopup;

			const params = { saveParams: saveParams };

			await this.saveCmpnMst_(params)
				.then(response => {
					if (response.header.message != undefined && response.header.message != null) {
						this.$sf_toast({
							type: response.header.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.header.messageCd)
						});
					}
					const cmpnNo = response.body.cmpnNo;

					this.getCmpnMstPopList_(cmpnNo);
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		deleteAction() {
			try {
				const deleteParams = this.cmpnMstPopup;

				//벨리데이션 체크
				this.insVali.validateSync(deleteParams);

				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('SWCC000108'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('SWCC000107'), clickFn: this.delete }] //삭제
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$sf_toggleLoading(false);
			}
		},
		async delete() {
			this.$sf_toggleLoading(true);
			try {
				const deleteParams = this.cmpnMstPopup;
				const cmpnNo = this.cmpnMstPopup.cmpnNo;

				const params = { cmpnNo: cmpnNo, deleteParams: deleteParams };

				const { code, messageCd } = await this.deleteCmpnMst_(params);

				if (code === 0 || code === 3) {
					this.$sf_toast({
						type: code === 0 ? 'ok' : 'error',
						message: this.getMessage_(messageCd)
					});
					code === 0 && this.$emit('RefreshMst');
				}
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			} finally {
				this.$emit('close');
				this.$sf_toggleLoading(false);
			}
		}
	},
	watch: {
		// sendParam1(newValue, oldValue) {
		// 	this.menuCmpnCd = this.sendParam1.cpnyCd;
		// 	this.menuCmpnNm = this.sendParam1.cpnyNm;

		// 	this.manuCmpn.cpnyCd = this.menuCmpnCd;
		// 	this.manuCmpn.cpnyNm = this.menuCmpnNm;
		// },
		sendParam2(newValue, oldValue) {
			this.phmnCd = this.sendParam2.commCd;
			this.phmnNm = this.sendParam2.commCdName;

			this.commCd.commCdType = this.sendParam2.commCdType;
			this.commCd.commCd = this.sendParam2.commCd;
		},
		sendParam3(newValue, oldValue) {
			this.causPartNo = this.sendParam3.partNo;
			this.causPartNm = this.sendParam3.partNm;
		}
	}
};
</script>

<style>
.sf-input-group-wrapper__label {
	color: aqua;
}
.search-option-wrapper__normal {
	position: relative;
}
.search-icon {
	color: var(--color-default);
	font-size: 1.5rem;
	position: absolute;
	right: 0;
	cursor: pointer;
	top: -3px;
}
</style>
